import ForgotPasswordResetFormView from './ForgotPasswordResetFormView';

export default ForgotPasswordResetFormView;